import React from 'react'
import { IVehicleProps } from 'utils/type'
import { ImageBase64 } from '../image/image'

interface IInputProps {
  vehicle: IVehicleProps
  vehicleDescription: string
  isLargeImage?: boolean
}

export const VehicleDescriptionBlock = (estimate: IInputProps) => {
  return (
    <div>
      <h3 className="text-dark mb-3 text-center">
        {estimate && estimate.vehicle && estimate.vehicle.id && parseInt(estimate.vehicle.year) > 0 && (
          <span>
            {estimate.vehicle.year} {estimate.vehicle.make}{' '}
            {estimate.vehicle.family}
          </span>
        )}
        {estimate && estimate.vehicle && !estimate.vehicle.id && (
          <span>{estimate.vehicleDescription}</span>
        )}
      </h3>
      {estimate && estimate.vehicle && estimate.vehicle.id && (
        <div className="text-center">{estimate.vehicleDescription}</div>
      )}
      <div
        className={
          estimate.isLargeImage
            ? 'car-image car-image-large mb-3 pb-0'
            : 'car-image mb-2'
        }
      >
        {estimate &&
          estimate.vehicle &&
          estimate.vehicle.id &&
          estimate.vehicle.vehicleImage && (
            <ImageBase64
              ImageBase64Encoded={estimate.vehicle.vehicleImage.base64Image}
            />
          )}
        {estimate &&
          (!estimate.vehicle ||
            !estimate.vehicle.id ||
            !estimate.vehicle.vehicleImage) && (
            <img src="/images/car-image-default.svg" alt="" />
          )}
      </div>

      <p className="text-smaller text-center">Image is indicative only</p>
    </div>
  )
}
